<template>
<div>
	<el-breadcrumb v-show="!isHomepage && levelList.length > 1" separator="/" class="bread-wrap">
		<transition-group name="breadcrumb">
			<el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
				<span v-if='item.redirect === "noredirect" || index === levelList.length - 1' class="no-redirect">{{ item.meta.title }}</span>
				<router-link v-else :to="item.redirect || item.path">{{ item.meta.title }}</router-link>
			</el-breadcrumb-item>
		</transition-group>
	</el-breadcrumb>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	data() {
		return {
			levelList: [],
			isHomepage: false,
			isTitle: false,
		}
	},
	watch: {
		$route(val) {
			// layout ==> {
			// 	navbar
			// 	sidebar（mainSide）
			// 	app-main（mainRoot） ==> {
			// 		breadcrumb（this）
			// 		router
			// 	}
			// 	footbar
			// }

			// 导航展开收起重置
			this.$parent.$parent.$refs['mainSide'].checkRoutes()

			// 切换路由时，回到顶部
			this.$root.$el.scrollTo(0, 0)

			// 初始化
			this.init()
		},
		hidebreads() {
			this.getBreadcrumb()
		}
	},
	created() {
		this.init()
	},
	computed: {
		...mapGetters([
			'uid',
			'hidebreads',
		]),
	},
	methods: {
		init() {
			let uid = this.uid
			const cookieUid = this.$util.getCookie('uid')
			if (!uid && cookieUid) {
				uid = cookieUid
			}
			// 历史url
			if (uid) {
				sessionStorage.setItem('historyUrl', `${ uid }_${ this.$route.path }`)
			} else {
				// 记录登录失效前的页面路径
				sessionStorage.setItem('un_login_historyUrl', `${ this.$route.path }`)
			}

			// 面包屑设置
			this.getBreadcrumb()
			// console.log(this.$route)
			// 查询未读消息等
			if (!['messageList'].includes(this.$route.name)) {
				this.$store.dispatch('checkMessageUnread')
			}
			this.$store.dispatch('checkAlert');
		},

		getBreadcrumb() {
			this.isTitle = false
			let matched = this.$route.matched.filter(item => {
				if (item && item.meta && item.meta.title) {
					return this.hidebreads.indexOf(item.meta.title) == -1
				} else {
					return false
				}
			})
			const first = matched[0]
			if (first) {
				if (matched.length == 1 && first.name == 'homepage') {
					this.isHomepage = true
				} else {
					this.isHomepage = false
					if (first.meta && first.meta.pointTo && first.meta.pointTo == '/homepage') {
						matched = [{ path: '/homepage', meta: { title: '首页' }}].concat(matched)
					}
				}
			}
			this.levelList = matched
			this.$nextTick(() => {
				this.isTitle = matched.length == 1
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.bread-wrap {
	display: block;
	width: 100%;
	padding-left: 12px;
	font-size: 12px;
	line-height: 20px;
	margin: 24px 0 15px;
}
</style>
